<div class="main-block" [class]="{
	 	'col-2-i-l': leftIcon && !rightIcon,
	 	'col-2-i-r': !leftIcon && rightIcon,
	 	'col-3-i-rl': leftIcon && rightIcon}">
	<div class="left-icon">
		<mat-icon *ngIf="leftIcon" [class]="lClassName" [svgIcon]="leftIcon"></mat-icon>
	</div>
	<div class="inputAndClose">
		<div class="inputArea">
			<input #input [value]="value" [type]="type" [placeholder]="placeholder" (keyup)="onChange(input.value)"
				(keyup.enter)="onEnter(input.value)" (focusin)="onFocusIn(input.value)"
				(focusout)="onFocusOut(input.value)" [disabled]=disabled />
		</div>
		<span class="close" *ngIf="isClose" (click)="onCloseClick()">x</span>

	</div>
	<div class="right-icon">
		<mat-icon *ngIf="rightIcon" (click)="onClick(input.value)" [svgIcon]="rightIcon" [class]="rClassName"
			mat-ripple></mat-icon>
	</div>
</div>